import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

/**
 * ConfirmDialog Wrapper-Komponente
 * 
 * Wrappet PrimeNG's ConfirmDialog für globale Verwendung.
 * 
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [ConfirmDialogModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {

  constructor() {}

}
